import { render } from "./AppAdd.vue?vue&type=template&id=7d0ebcc4&scoped=true"
import script from "./AppAdd.vue?vue&type=script&lang=js"
export * from "./AppAdd.vue?vue&type=script&lang=js"

import "./AppAdd.vue?vue&type=style&index=0&id=7d0ebcc4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7d0ebcc4"

export default script